import { render, staticRenderFns } from "./DocumentPortalSetupView.vue?vue&type=template&id=698dffac&scoped=true&"
import script from "./DocumentPortalSetupView.vue?vue&type=script&setup=true&lang=js&"
export * from "./DocumentPortalSetupView.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./DocumentPortalSetupView.vue?vue&type=style&index=0&id=698dffac&prod&scoped=true&lang=css&"
import style1 from "./DocumentPortalSetupView.vue?vue&type=style&index=1&id=698dffac&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "698dffac",
  null
  
)

export default component.exports